import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { formatApiError } from '@/lib/api';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_donor-connect-82/artifacts/itf8zcku_mmcdf_logo_2-removebg-preview.png";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page" data-testid="login-page">
      <div className="login-container" data-testid="login-container">
        {/* Logo */}
        <div className="login-logo-wrap">
          <img src={LOGO_URL} alt="Mushayamunda Christian Foundation" className="login-logo" />
          <p className="login-subtitle">Donation Management Platform</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="login-form" data-testid="login-form">
          {error && (
            <div className="login-error" data-testid="login-error">{error}</div>
          )}

          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            required
            className="login-input"
            data-testid="login-email-input"
          />

          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            required
            className="login-input"
            data-testid="login-password-input"
          />

          <button
            type="submit"
            disabled={loading}
            className="login-button"
            data-testid="login-submit-btn"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p className="login-footer">Mushayamunda Christian Foundation</p>
      </div>
    </div>
  );
}
